export interface Location {
    id: string;
    name: string;
    address: string;
    landmark: string;
    phone: string;
    mobile: string;
    mapsUrl?: string;
}

export const locations: Location[] = [
    {
        id: 'sediu-1',
        name: 'Sediul 1',
        address: 'Piata Revolutiei nr. 13, parter',
        landmark: 'in spatele Teatrului Mihai Eminescu, langa Prefectura, CEC Bank si Galeriile de arta Stefan Luchian',
        phone: '0331.402.564',
        mobile: '0740.207.134',
        mapsUrl: 'https://maps.google.com/?q=Piata+Revolutiei+13+Botosani',
    },
    {
        id: 'sediu-2',
        name: 'Sediul 2',
        address: 'Str. Armeana nr. 50',
        landmark: 'Piata Mare, langa Biserica Armeneasca veche',
        phone: '0331.402.564',
        mobile: '0740.039.340',
        mapsUrl: 'https://maps.google.com/?q=Str+Armeana+50+Botosani',
    },
];
